import { render } from "./DocumentsListSigned.vue?vue&type=template&id=61065d3e&scoped=true"
import script from "./DocumentsListSigned.vue?vue&type=script&lang=js"
export * from "./DocumentsListSigned.vue?vue&type=script&lang=js"

import "./DocumentsListSigned.vue?vue&type=style&index=0&id=61065d3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61065d3e"]])

export default __exports__